// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nx1V","buttons":"styles_buttons__2fgwH"};